const DEFAULT_BANNER_HEIGHT = 44;


const ENABLE_DISCLAIMER_BANNERS = false;

const SEARCH_SPACE_BANNERS = {
    in: {
        default: {
            message: "Disclaimer: AInstein4IN is currently in UAT (User Acceptance Testing).",
        },

        routes: {
            /*
            "/analysis": {
                message: "Disclaimer: Analysis data for AInstein4IN is currently in UAT.",
            },
            */
        },
    },
};

const ROUTE_BANNERS = {
    /*
    "/settings": {
        message: "Disclaimer: Settings changes may take a few minutes to propagate.",
    },
    */
};

const DISABLED_ROUTES = [];

export function getDisclaimerBannerConfig({ route, searchSpace }) {
    if (!ENABLE_DISCLAIMER_BANNERS) {
        return null;
    }

    if (!route || DISABLED_ROUTES.includes(route)) {
        return null;
    }

    const routeSpecificSpaceBanner =
        SEARCH_SPACE_BANNERS[searchSpace]?.routes?.[route] || null;

    const spaceDefaultBanner =
        SEARCH_SPACE_BANNERS[searchSpace]?.default || null;

    const routeFallbackBanner =
        ROUTE_BANNERS[route] || null;

    const resolvedBanner =
        routeSpecificSpaceBanner ||
        spaceDefaultBanner ||
        routeFallbackBanner ||
        null;

    if (!resolvedBanner?.message) {
        return null;
    }

    return {
        height: DEFAULT_BANNER_HEIGHT,
        ...resolvedBanner,
    };
}